import React, { createContext, useContext, useEffect, useState } from 'react';
import serviceManager from '../services/ServiceManager';

const ServiceContext = createContext(null);

export const ServiceProvider = ({ children }) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      await serviceManager.initialize();
      setReady(true);
    };
    init();
  }, []);

  if (!ready) {
    // You can show a splash screen or loading indicator
    return null; // or <LoadingScreen />
  }

  return (
    <ServiceContext.Provider value={serviceManager}>
      {children}
    </ServiceContext.Provider>
  );
};

export const useService = (serviceName) => {
  const manager = useContext(ServiceContext);
  if (!manager) {
    throw new Error('useService must be used within ServiceProvider');
  }
  return manager.get(serviceName);
};

// Optional: specific hooks for commonly used services
export const useDatabase = () => useService('databaseService');
export const useApi = () => useService('apiService');
export const useSync = () => useService('syncService');
export const useBusinessApi = () => useService('businessApiService');
export const useSubmission = () => useService('submissionService');
// ... add more as needed